import { Button, Modal, Stack, Typography } from '@mui/material'
import XMarkSvg from '~/@ui/_sharedSvgs/FontAwesome/XMark.svg?react'

interface Props {
  isDeleteOpen: boolean
  closeDelete: () => void
  deleteRequest: () => void
}

export const DeleteModal = ({
  isDeleteOpen,
  closeDelete,
  deleteRequest,
}: Props) => {
  return (
    <Modal
      open={isDeleteOpen}
      onClose={closeDelete}
      className="justify-items-center self-center p-6">
      <Stack className="max-w-[340px] p-4 bg-zGrey200 rounded-4d">
        <Stack className="flex-row justify-between">
          <Typography className="text-base font-bold text-zBlack200">
            Ste si istý?
          </Typography>
          <Button className="w-11 h-8 bg-zGrey250" onClick={closeDelete}>
            <XMarkSvg />
          </Button>
        </Stack>

        <Typography className="text-3d font-medium text-zGrey400 mt-4">
          Naozaj by ste zrušili Žiadosť o Druhý dôchodok?
        </Typography>

        <Button
          variant="contained"
          className="w-fit h-14 self-center px-6 mt-6"
          onClick={deleteRequest}>
          Áno, zrušiť žiadosť
        </Button>
      </Stack>
    </Modal>
  )
}
